export default __webpack_public_path__ + "static/esso_1_box-4d130097cfe21c3b511d1ac326f1a47f.png";